import { render } from "./ModalUsuariosCompartidos.vue?vue&type=template&id=6b28ac3d"
import script from "./ModalUsuariosCompartidos.vue?vue&type=script&lang=js"
export * from "./ModalUsuariosCompartidos.vue?vue&type=script&lang=js"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__